import { Box, type BoxProps } from '@mui/material';

import loginBackground from '../../assets/login-background.avif';

type HeroImageProps = Pick<BoxProps, 'className'>;

const HeroImage = ({ className }: HeroImageProps): JSX.Element => (
  <Box
    className={className}
    sx={[
      {
        backgroundImage: `url("${loginBackground}")`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
      },
      !className && { width: '100%', height: '100%' },
    ]}
  />
);

export default HeroImage;
